module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-fadd5e268e4afe54a78fa771333f1b2c.ttf";